import { Typography } from "@material-ui/core";
import React from "react";
import {
	getGameType,
	getMaxGamesPerSet,
	getMaxTieBreakPoints
} from "@prestosports/prestostats-core/Tennis";
import matchSettingsStyles from "../styles/MatchSettings.styles";
import { useEventContext } from "../../../state/events/context";

const MatchSettings = ({
	match,
	maxGameSet,
	maxTiebreak,
	showGameType = true
}) => {
	const classes = matchSettingsStyles();
	const { state: eventState } = useEventContext();
	const { gameConfiguration } = eventState.currentEventSettings() || {};
	const maxSetValue = maxGameSet || getMaxGamesPerSet(match, gameConfiguration);
	const maxTiebreakValue =
		maxTiebreak || getMaxTieBreakPoints(match, gameConfiguration);
	const gameType = getGameType(match, gameConfiguration);

	return (
		<Typography className={classes.settings} variant="subtitle1">
			Game Set Max: <span className={classes.settingValue}>{maxSetValue}</span> /
			Tie Break Max:{" "}
			<span className={classes.settingValue}>{maxTiebreakValue}</span>
			{showGameType && (
				<>
					{" "}
					/ Game Type: <span className={classes.settingValue}>{gameType.name}</span>
				</>
			)}
		</Typography>
	);
};

export default MatchSettings;
